<template v-if="currentTab === 'media'">
  <div class="company-sections-wrapper">
    <section id="company-logo" class="d-flex flex-column" data-testid="company-media-logo">
      <h3>{{ $t('settings.company.media.upload_logo') }}</h3>
      <p class="text-muted">{{ $t('settings.company.media.upload_logo.hint') }}</p>
      <DropFiles
        style="width: 200px"
        :key="modelValue.companyLogo.length"
        v-model="modelValue.companyLogo"
        ref="logoDropzone"
        :allowSelection="false"
        :media-count="1" />
    </section>
    <section id="company-logo" class="d-flex flex-column mt-4" data-testid="company-media-images">
      <h3>{{ $t('settings.company.media.company_images') }}</h3>
      <p class="text-muted">{{ $t('settings.company.media.company_images.hint') }}</p>
      <DropFiles v-model="modelValue.images" :allowSelection="false" :grid-columns="5" />
    </section>
    <section id="company-brand-colors" class="d-flex flex-column mt-4">
      <h3>{{ $t('settings.company.media.brand_colours') }}</h3>
      <p class="text-muted">{{ $t('settings.company.media.brand_colours.hint') }}</p>
      <BrandColorFields v-model="brandColors" />
    </section>
    <LoadingButton
      class="btn btn-primary mt-4"
      data-testid="company-media-save"
      @press="(stopLoading) => emit('save', stopLoading)">
      {{ $t('company.save.button') }}
    </LoadingButton>
  </div>
</template>
<script setup lang="ts">
import DropFiles from '@/components/common/DropZone/DropZone.vue';
import BrandColorFields from '@/components/generic/BrandColorFields.vue';
import type { BrandColor } from '@/types/company';
import type { OrderMedia } from '@/types/types';
import { LoadingButton } from '@prospective/lithium';

const modelValue = defineModel<OrderMedia>({ required: true });
const brandColors = defineModel<BrandColor[]>('brandColors', { required: true });

const emit = defineEmits<{
  (e: 'save', stopLoading: () => void): void;
}>();
</script>
